import React from 'react';
import { render } from 'react-dom';
import ResizeObserver from 'resize-observer-polyfill';

import I18nLoader from 'react-i18n';

import App from 'App/App';

import 'isomorphic-fetch';
import 'number-to-locale-string';

declare global {
  interface Window {
    ResizeObserver: any;
  }
}

window.ResizeObserver = ResizeObserver;

const AppWithLoaders = (
  <I18nLoader>
    <App />
  </I18nLoader>
);
const root = document.getElementById('root');

if (process.env.REACT_STRICT_MODE) {
  render(<React.StrictMode>{AppWithLoaders}</React.StrictMode>, root);
} else {
  render(AppWithLoaders, root);
}
